import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'none',
    paddingBottom: pxToRem(48),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: pxToRem(88),
    },
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      marginTop: theme.spacing(11),
    },
    '& .at-style-responsive .at-share-btn': {
      margin: 0,
      ...theme.mixins.marginRight(pxToRem(10)),
    },
    '& a:last-child': {
      backgroundColor: '#FF8707 !important',

      '& svg': {
        fill: `${theme.palette.common.white} !important`
      }
    },
    '& .socialWrapper': {
      display: 'flex',
      alignItems: 'center',
      '& .st-custom-button': {
        cursor: 'pointer',
        minHeight: '40px',
        minWidth: '40px',
        background: 'rgba(221, 222, 222, 0.2)',
        borderRadius: '50px',
        ...theme.mixins.marginRight(9),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'ease 0.3s all',
        '&.orange': {
          background: 'transparent',
          minHeight: '40px',
          minWidth: '40px',
          '&:hover': {
            background: 'transparent',
          },
          '& svg': {
            width: '40px',
            height: '40px',
          },
        },
        '& svg': {
          width: '24px',
          height: '24px',
          '&.svgInner': {
            '& path': {
              fill: '#000',
              transition: 'ease 0.3s all',
              '&.grey': {
                fill: '#fff',
              }
            }
          }
        },
        '&:hover': {
          transition: 'ease 0.3s all',
          background: 'rgb(255, 135, 7)',
          '& svg': {
            '&.svgInner': {
              '& path': {
                fill: '#fff',
                '&.grey': {
                  fill: 'rgb(255, 135, 7)',
                }
              }
            }
          }

        }
      }
    },
  },
  header: {
    [theme.breakpoints.up('lg')]: {
      marginBottom: pxToRem(24),
    },
  },
}));

export default useStyles;
